import { render, staticRenderFns } from "./Org.vue?vue&type=template&id=3a40fa0a&"
import script from "./Org.vue?vue&type=script&lang=js&"
export * from "./Org.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports